module.exports = __webpack_public_path__ + "static/img/verification-img.388ef2fb.png";